"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LIB_VERSION = void 0;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const packageJson = require('../package.json');
exports.LIB_VERSION = packageJson.version;
//# sourceMappingURL=version.js.map